// Ícone da marca (logo Trakd). O /icon.svg tem filtro de ruído + blurs pesados que
// o Safari mobile rasteriza feio em tamanho pequeno; então no MOBILE servimos o PNG
// limpo (/icons/icon-192.png) e no DESKTOP mantemos o SVG (idêntico ao que já era).
// O <picture> escolhe a fonte por media query; display:contents preserva o layout
// do <img> original (margens/flex/grid/animações via className continuam valendo).

interface BrandIconProps {
  size: number;
  className?: string;
  alt?: string;
}

export function BrandIcon({ size, className, alt = '' }: BrandIconProps) {
  return (
    <picture style={{ display: 'contents' }}>
      <source media="(min-width: 880px)" srcSet="/icon.svg" />
      {/* mobile: PNG limpo */}
      <img
        src="/icons/icon-192.png"
        width={size}
        height={size}
        alt={alt}
        className={className}
        decoding="async"
      />
    </picture>
  );
}

export default BrandIcon;
